<template>
  <el-dialog
    v-drag
    v-loading="laoding"
    :visible.sync="dialogVisible"
    width="800px"
    :title="!rowData?.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="0"
  >
    <div class="content">
      <el-form ref="form" label-position="top" :model="form" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="单号" prop="serviceNo">
              <el-input
                v-model="form.serviceNo"
                :disabled="true"
                style="width: 320px;"
                placeholder="请输入">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户" prop="companyId" style="width: 320px;">
              <el-select
                v-model="form.companyId"
                placeholder="请选择"
                style="width: 320px;"
                filterable
                clearable
              >
                <el-option
                  v-for="item in companyDrapdown"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="供应商" prop="supplierId" style="width: 320px;">
              <el-select
                v-model="form.supplierId"
                placeholder="请选择"
                style="width: 320px;"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in supplierOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成本" prop="cost" style="width: 320px;">
              <el-input-number v-model="form.cost" style="width: 100%;" :min="0" :precision="2" :step="0.01" controls-position="right">
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="otherServiceTypeIds">
              <span slot="label">业务类型<span class="tip">(可多选)</span></span>
              <el-checkbox-group v-model="form.otherServiceTypeIds">
                <el-checkbox
                  v-for="item in otherServiceTypeOptions"
                  :key="item.id"
                  :label="item.id"
                >{{ item.typeName }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="参考单号1" prop="referenceNumber">
              <el-input
                v-model="form.referenceNumber"
                style="width: 320px;"
                placeholder="请输入">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参考单号2" prop="referenceNumber2">
              <el-input
                v-model="form.referenceNumber2"
                style="width: 320px;"
                placeholder="请输入">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="业务需求补充" prop="demandAdditional">
              <el-input
                v-model="form.demandAdditional"
                style="width: 100%;"
                placeholder="请输入">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="form.remark"
                style="width: 100%;"
                placeholder="请输入">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!rowData?.id">
          <el-col :span="24">
            <el-form-item prop="remark">
              <span>上传附件<span class="tip">(最多可上传2个文件)</span></span>
              <div class="upload">
                <el-upload
                  class="upload-demo"
                  drag
                  :action="`/api/SystemFile/uploadFile?source=12`"
                  :headers="headers"
                  list-type="picture"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                  :show-file-list="false"
                >
                  <svg-icon iconClass="upload" className="icon" />
                </el-upload>
                <div v-for="(item, $index) in fileList" :key="$index" class="fileList">
                  <div class="progress">
                    <el-progress
                      type="circle"
                      :width="40"
                      :height="40"
                      :stroke-width="4"
                      :percentage="100"
                    ></el-progress>
                  </div>
                  <div class="file">
                    <p v-tooltip="166" class="fileName">{{ item.fileName }}</p>
                    <p class="fileSize">{{ item.fileSize }} KB</p>
                  </div>
                  <div class="opt">
                    <i class="el-icon-delete" title="删除" @click="deleteFile($index, item.id)" />
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div v-debounce-click="{ value: ok, args: ['form'] }" class="ok flex_c_c">确 定</div>
    </span>
  </el-dialog>
</template>

<script>
import {
  getOtherServiceNumber,
  modifyOtherService
} from '@/api/other'
import {
  deleteSystemFile
} from '@/api/setting'
import config from '@/utils/config'
import { mapGetters } from 'vuex'
import { myMixins } from '@/mixins'
export default {
  mixins: [myMixins],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    otherServiceTypeOptions: {
      type: Array,
      default: () => []
    },
    supplierOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config,
      form: {
        serviceNo: '', // 单号
        companyId: '', // 客户
        supplierId: '', // 供应商
        referenceNumber: '', // 参考单号1
        referenceNumber2: '', // 参考单号2
        demandAdditional: '', // 业务需求补充
        remark: '', // 备注
        otherServiceTypeIds: [], // 业务类型
        fileIds: [],
        cost: ''
      },
      rules: {
        serviceNo: [
          { required: true, message: '请输入单号', trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        supplierId: [
          { required: true, message: '请选择供应商', trigger: 'change' }
        ],
        otherServiceTypeIds: [
          { required: true, message: '请选择业务类型', trigger: 'change' }
        ],
        referenceNumber: [
          { required: true, message: '请输入参考单号1', trigger: 'blur' }
        ],
        referenceNumber2: [
          { required: true, message: '请输入参考单号2', trigger: 'blur' }
        ],
        demandAdditional: [
          { required: true, message: '请输入业务需求补充', trigger: 'blur' }
        ]
      },
      laoding: false,
      fileList: [],
      headers: { 'ESCLEARANCE': btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`) }
    }
  },
  computed: {
    ...mapGetters(['companyDrapdown'])
  },
  watch: {
    dialogVisible(val) {
      this.reset()
      if (val && !this.rowData?.id) {
        this.getAddOtherNumber()
      }
      if (val) {
        this.rowData?.id && (this.form = {
          ...this.rowData,
          otherServiceTypeIds: this.rowData.otherServiceType.map(a => a.id),
          companyId: this.rowData.companyId.toString(),
          fileIds: []
        })
        // this.getCommData()
      } else {
        this.$refs['form']?.resetFields()
      }
    }
  },
  methods: {
    reset() {
      this.form = {
        serviceNo: '', // 单号
        companyId: '', // 客户
        supplierId: '', // 供应商
        referenceNumber: '', // 参考单号1
        referenceNumber2: '', // 参考单号2
        demandAdditional: '', // 业务需求补充
        remark: '', // 备注
        otherServiceTypeIds: [], // * 业务类型
        fileIds: [],
        cost: ''
      }
      this.fileList = []
    },
    cancel() {
      this.reset()
        this.$refs['form']?.resetFields()
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          this.laoding = true
          try {
            const params = {
              ...this.form,
              id: this.rowData?.id || undefined
            }
            const res = await modifyOtherService(params)
            this.laoding = false
            if (res.success) {
              this.$message.success(res.errorMessage)
              this.reset()
              this.$emit('ok')
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            this.laoding = false
            console.error(error)
          }
        } else {
          return false
        }
      })
    },
    async getAddOtherNumber() {
      try {
        const res = await getOtherServiceNumber()
        if (res.success) {
          this.form.serviceNo = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleSuccess(e, file) {
      const lastFile = this.fileList[this.fileList.length - 1]
      this.fileList.splice(this.fileList.length - 1, 0, {
        ...lastFile,
        fileName: file.name,
        fileSize: Math.ceil(file.size / 1024),
        id: e.data.id
      })
      this.form.fileIds.push(e.data.id)
    },
    async deleteFile(index, id) {
      try {
        const res = await deleteSystemFile({ fileId: id })
        if (res.success) {
          this.fileList.splice(index, 1)
          this.form.fileIds.splice(index, 1)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    beforeUpload(file) {
      const suffix = file.name.slice(
        file.name.lastIndexOf('.') + 1,
        file.name.length
      ).toLowerCase()
      if (!(suffix === 'jpg' || suffix === 'jpeg' || suffix === 'png' || suffix === 'pdf')) {
        this.$message.error('请上传图片或pdf文件')
        return false
      } else {
        if (this.fileList.length === 2 && this.form.fileIds.length === 2) {
          this.form.fileIds.shift()
          this.fileList.shift()
        }
        return true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 80px);
  margin: 0 auto;
  .el-row {
    .el-col:nth-child(even) {
      display: flex;
      justify-content: flex-end;
    }
  }
  .upload {
    display: flex;
    /deep/ .upload-demo {
      .el-upload-dragger {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 64px;
        height: 64px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        .icon {
          font-size: 24px;
          color: #cdcdcd;
        }
      }
    }
    .fileList {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 260px;
      height: 64px;
      box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.1);
      border-radius: 6px 6px 6px 6px;
      margin-left: 15px;
      box-sizing: border-box;
      padding: 0 10px;
      & > div {
        line-height: normal;
      }
      .progress {
        width: 40px;
        height: 40px;
      }
      .file {
        width: 166px;
        .fileName {
          font-size: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .fileSize {
          font-size: 12px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }
      }
      .opt {
        .el-icon-delete {
          font-size: 24px;
          color: #cdcdcd;
          cursor: pointer;
        }
      }
    }
  }
  .tip {
    color: #FE453D;
    font-size: 12px;
  }
}
.footers {
  display: flex;
  justify-content: center;
  & > div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
  .cancel {
    background: #EEEEEE;
    color: #999999;
    margin-right: 16px;
  }
  .ok {
    background: #2395f3;
    color: #ffffff;
  }
}
</style>
